/**
 * The admin panel lives at a private address. Only a hash of it ships in the site's code, so reading
 * the public JavaScript does not reveal it. To move the panel, put the new hash here:
 *   node -e "<cyrb53 below>; console.log(cyrb53('new-address', 7381))"
 * The old /admin address now shows the normal "page not found".
 */
const ADMIN_PATH_HASH = 5810835700346345;
const SEED = 7381;

/** cyrb53: a small, fast 53-bit string hash (not for passwords; only to avoid shipping the address). */
function cyrb53(text: string, seed: number) {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i);
    h1 = Math.imul(h1 ^ code, 2654435761);
    h2 = Math.imul(h2 ^ code, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

/** True for the private admin address (first path segment), e.g. "/<address>" or "/<address>/". */
export function isAdminPath(pathname: string) {
  const segment = (pathname.split('/')[1] || '').toLowerCase();
  return segment.length >= 6 && cyrb53(segment, SEED) === ADMIN_PATH_HASH;
}
